import React, { useContext, useState, useRef, useEffect } from 'react'

import { Link } from 'react-router-dom'
import {
  makeStyles,
  Grid,
  TextField,
  Button,
  IconButton,
} from '@material-ui/core'
import { ArrowDropUp, ArrowDropDown } from '@material-ui/icons'

import { CategoryContext } from '../context/CategoryContext'
import { ProductsContext } from '../context/ProductsContext'

import priceDtoHelper from '../../../shared/PriceDtoHelper'
import InriverImage from '../../../core/components/InriverImage'
import TranslationLabel from '../../../core/components/TranslationLabel'

import StockItem from './StockItem'
import AddIcon from '@material-ui/icons/Add'

const useStyles = makeStyles((theme) => ({
  imgWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  imgWrapperInner: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  label: {
    textTransform: 'uppercase',
    fontSize: 11,
    position: 'absolute',
    top: 5,
    left: 7,
    backgroundColor: 'rgba(255, 255, 255, .6)',
    padding: '1px 3px',
    color: theme.palette.grey[600],
  },
  labelDiscount: {
    left: 'auto',
    right: 7,
    fontWeight: 'bold',
    fontSize: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    margin: '0 10px',
    display: 'block',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  small: {
    fontSize: 13,
  },
  listOpenOrders: {
    fontSize: 13,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  listReservations: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  productAndStockItem: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[200],
    paddingBottom: 5,
    marginTop: 5,
    padding: '0 10px',
    flexWrap: 'wrap',
  },
  gridItem: {
    padding: '8px',
  },
  box: {
    borderWidth: 1,
    borderColor: theme.palette.grey[200],
    borderStyle: 'solid',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
  },
  head: {
    position: 'relative',
    height: 0,
    overflow: 'hidden',
    paddingTop: '71.5%',
  },
  info: {
    marginTop: 'auto',
  },
  quantityOptionsHeader: {
    display: 'block',
    marginRight: '15px',
  },
  quantityOptionsCell: {
    display: 'block',
    whiteSpace: 'nowrap',
  },

  quantity: {
    'width': '64px',

    '& input': {
      textAlign: 'center',
    },
    // Target Chrome, Safari, Edge
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      'margin': 0,
    },
    // Target Firefox
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
  priceNormal: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: 'block',
  },
  priceText: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: 'inline-block',
    marginLeft: 10,
  },
  currency: {
    position: 'absolute',
    top: '-16px',
    left: '62px',
    color: theme.palette.grey[600],
    fontSize: 12,
  },

  priceYours: {
    fontSize: 16,
    fontWeight: 'bold',
    display: 'inline-block',
  },
  btn: {
    'color': 'white',
    'backgroundColor': 'black',
    'flexGrow': 1,
    'height': 40,
    'marginLeft': '5px',

    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
  },
  tableCell: {
    position: 'relative',
    padding: '5px 5px',
    whiteSpace: 'nowrap',
  },
}))

export default function GridView(props) {
  const classes = useStyles()
  const { enableProductLink = true } = props

  if (!props.products) {
    return <></>
  }

  return (
    <Grid
      container
      spacing={0}
      style={{ padding: '0 10px', margin: 0, width: '100%' }}>
      {props.products.map((product, i) => (
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          lg={3}
          xl={3}
          key={product.productNo}
          className={classes.gridItem}>
          <div className={classes.box}>
            <Cell
              key={product.productNo}
              product={product}
              classes={classes}
              enableProductLink={enableProductLink}
              {...props}
            />
          </div>
        </Grid>
      ))}
    </Grid>
  )
}

const Cell = (props) => {
  //The product state below is not used, but through the update/setProduct a rerender is caused when needed
  const [product, setProduct] = useState({ ...props.product })

  const options = {
    ...props,
    update: setProduct,
  }

  const categories = useContext(CategoryContext)
  const productsModel = useContext(ProductsContext)
  const [currentPrice, setCurrentPrice] = useState(
    priceDtoHelper.findPrice(props.product.colli, props.product),
  )
  const settings = { disabledBuyButton: false, ...props }

  return (
    <>
      <Grid
        item
        className={props.classes.head}>
        <div className={props.classes.imgWrapper}>
          {props.enableProductLink ? (
            <Link
              to={`/sales/products/item/${props.product.productNo}`}
              onClick={productsModel.gotoProduct}
              className={props.classes.imgWrapperInner}>
              <InriverImage
                className={props.classes.img}
                productNo={props.product.productNo}
                displayConfig='SalesSite_Large'
                alt={props.product.description}
                showImage={props.product.showImage}
              />
            </Link>
          ) : (
            <div className={props.classes.imgWrapperInner}>
              <InriverImage
                className={props.classes.img}
                productNo={props.product.productNo}
                displayConfig='SalesSite_Large'
                alt={props.product.description}
                showImage={props.product.showImage}
              />
            </div>
          )}
        </div>

        <span className={props.classes.label}>
          {getBrandLabel(props.product.brandNo, categories)}
        </span>

        {priceDtoHelper.hasDiscount(currentPrice) && (
          <span
            className={`${props.classes.label} ${props.classes.labelDiscount}`}>
            -{currentPrice.discountPercentage}%
          </span>
        )}
      </Grid>
      <Grid item>
        {props.enableProductLink ? (
          <Link
            to={`/sales/products/item/${props.product.productNo}`}
            onClick={productsModel.gotoProduct}
            className={props.classes.title}>
            {props.product.description}
          </Link>
        ) : (
          <span className={props.classes.title}>{props.product.description}</span>
        )}
      </Grid>

      <div className={props.classes.productAndStockItem}>
        <Grid container>
          <Grid
            item
            className={props.classes.info}
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px' }}>
            <span className={props.classes.small}>
              <TranslationLabel name='productNumber' />
              <span> {props.product.productNo}</span>
            </span>
            {/* Open Orders and Reservations Modal Triggers - horizontal layout */}
            {(props.product.openOrders?.length > 0 || props.product.reservations?.length > 0) && (
              <>
                {props.product.openOrders?.length > 0 && (
                  <div
                    onClick={() =>
                      props.setOpenOrdersModal(props.product.productNo)
                    }>
                    <span className={props.classes.listOpenOrders}>
                      <TranslationLabel name='openOrders' />
                    </span>
                  </div>
                )}
                {props.product.reservations?.length > 0 && (
                  <div
                    onClick={() =>
                      props.setReservationsModal(props.product.productNo)
                    }>
                    <span className={props.classes.listReservations}>
                      <TranslationLabel name='reservationBreakDown' />
                    </span>
                  </div>
                )}
              </>
            )}
          </Grid>
          <Grid
            item
            style={{
              textAlign: 'right',
              padding: '5px',
              flexGrow: 1,
              alignSelf: 'center',
            }}>
            {/* ...existing code... */}
          </Grid>
        </Grid>

        <Grid
          item
          className={props.classes.info}>
          <StockItem
            text={props.product.inventoryText}
            status={props.product.inventoryStatus}
          />
        </Grid>
      </div>

      <Grid container>
        <Grid
          item
          style={{
            padding: '5px 5px 0px 5px',
            margin: '5px 5px 0px 5px',
          }}>
          <RenderCellSalesUnitDetails {...options} />
        </Grid>
        <Grid
          item
          style={{
            textAlign: 'right',
            padding: '5px',
            flexGrow: 1,
            alignSelf: 'center',
          }}>
          <RenderCellPrice {...options} />
        </Grid>
      </Grid>

      <Grid
        item
        style={{ padding: '5px 10px', display: 'flex', alignItems: 'center' }}>
        <RenderCellQuantity {...options} />
        <Button
          disabled={
            priceDtoHelper.hasNoPrice(props.product) ||
            settings.disabledBuyButton
          }
          variant='contained'
          disableElevation
          className={props.classes.btn}
          onClick={() => props.addToBasket(props.product)}>
          <AddIcon />
        </Button>
      </Grid>
    </>
  )
}

const getBrandLabel = (id, categories) => {
  if (!categories) {
    return null
  }
  const brandItem =
    categories.brands && categories.brands.find((el) => el.id === id)
  return brandItem && brandItem.label
}

const RenderCellQuantity = (props) => {
  const inputRef = useRef(null)

  useEffect(() => {
    //Set quantity to lowest campaign Quantity if exists
    props.product.quantity = priceDtoHelper.getCampaignQuantity(props.product)
  }, [])

  useEffect(() => {
    if (!props.product.quantity) {
      return
    }

    if (props.product.quantity <= 0) {
      handleChangeQuantity({
        target: {
          //Backend always secure at least 1 in value
          value: props.product.minimumQuantity,
        },
      })
    }
  }, [props.product])

  const onBlurHandler = (e) => {
    props.product.quantity = priceDtoHelper.findNextAllowedQuantity(
      props.product,
      e.target.value,
    )

    props.update({ ...props.product })
  }

  const handleChangeQuantity = (e) => {
    const val = e.target.value
    props.product.quantity = val

    //This ends up with a setProduct that update state and rerenders the component
    props.update({ ...props.product })
  }

  const incrementQuantity = () => {
    const currentQuantity = props.product.quantity
    const newQuantity = priceDtoHelper.GetNextIncrementQuantity(
      props.product,
      currentQuantity,
    )
    handleChangeQuantity({
      target: {
        value: newQuantity,
      },
    })
  }

  const decrementQuantity = () => {
    const currentQuantity = props.product.quantity

    const newQuantity = priceDtoHelper.GetNextDecrementQuantity(
      props.product,
      currentQuantity,
    )

    if (newQuantity >= props.product.minimumQuantity) {
      handleChangeQuantity({
        target: {
          value: newQuantity,
        },
      })
    }
  }

  return (
    <div
      className={props.classes.tableCellQuantity}
      style={{ display: 'flex', alignItems: 'center' }}>
      {/* Arrow buttons (stacked vertically) */}
      <div
        className={props.classes.tableCellArrow}
        style={{ display: 'flex', flexDirection: 'column' }}>
        {/* Increment Button */}
        <IconButton
          size='small'
          onClick={incrementQuantity}>
          <ArrowDropUp />
        </IconButton>

        {/* Decrement Button */}
        <IconButton
          size='small'
          onClick={decrementQuantity}
          disabled={props.product.quantity <= props.product.minimumQuantity}>
          <ArrowDropDown />
        </IconButton>
      </div>

      {/* Quantity Input */}
      <TextField
        onBlur={onBlurHandler}
        size='small'
        type='number'
        value={props.product.quantity || 0}
        onChange={handleChangeQuantity}
        className={props.classes.quantity}
        inputRef={inputRef}
        onClick={() => {
          inputRef.current.select(0, -1)
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowUp') {
            e.preventDefault()
            incrementQuantity()
          }
          if (e.key === 'ArrowDown') {
            e.preventDefault()
            decrementQuantity()
          }
        }}
        label={<TranslationLabel name='numberOf' />}
        variant='outlined'
      />
    </div>
  )
}

const RenderCellPrice = (props) => {
  const currentPrice = priceDtoHelper.findPrice(
    props.product.quantity || props.product.colli,
    props.product,
  )
  return (
    <div
      className={props.classes.tableCell}
      style={{ textAlign: 'right' }}>
      {!props.showRetailPrice && (
        <>
          {priceDtoHelper.hasDiscount(currentPrice) && (
            <del className={props.classes.priceNormal}>
              {currentPrice.grossPrice}
            </del>
          )}

          {(currentPrice.priceType === priceDtoHelper.priceEnum.Campaign ||
            currentPrice.priceType === priceDtoHelper.priceEnum.Archive) && (
            <del className={props.classes.priceNormal}>
              {currentPrice.grossPrice}
            </del>
          )}

          <span className={props.classes.priceYours}>
            {currentPrice.netPrice}
          </span>
        </>
      )}

      {props.showRetailPrice && (
        <span className={props.classes.priceYours}>
          {props.product.recommendedRetailPrice}
        </span>
      )}
    </div>
  )
}

const RenderCellSalesUnitDetails = (props) => {
  const standardPrice = props.product.priceDtos.find(
    (e) => e.priceType === priceDtoHelper.priceEnum.Standard,
  )

  return (
    <div className={props.classes.tableCell}>
      {/* Split Colli Quantity */}
      {standardPrice && props.product.colli !== 1 && (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <TranslationLabel name='splitColliQuantity' />
          <span>
            1-{props.product.colli - 1}
            <TranslationLabel name='productsUnit' />
          </span>
        </div>
      )}

      {/* Price Dtos Mapping */}
      {props.product.priceDtos.map((price, i) => {
        let label, color

        if (
          price.priceType === priceDtoHelper.priceEnum.Standard &&
          price.priceValidFromQuantity === props.product.colli
        ) {
          label = <TranslationLabel name='salesColliQuantity' />
          color = null
        } else if (price.priceType === priceDtoHelper.priceEnum.Campaign) {
          label = <TranslationLabel name='campaignPrice' />
          color = 'green'
        } else if (price.priceType === priceDtoHelper.priceEnum.Archive) {
          label = <TranslationLabel name='ArchivePrice' />
          color = 'red'
        } else {
          return null // Skip if none of the conditions match
        }

        return (
          <div
            key={i}
            style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span
              className={props.classes.quantityOptionsHeader}
              style={{ color }}>
              {label}
            </span>
            <span>
              {price.priceValidFromQuantity}
              <TranslationLabel name='productsUnit' />
            </span>
          </div>
        )
      })}

      {/* Brownbox Information */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TranslationLabel name='Brownbox' />
        <span>
          {props.product.brownBox.numberOfItemsInBox}
          <TranslationLabel name='productsUnit' />
        </span>
      </div>
    </div>
  )
}
